
















































































































import { Component, Watch, Vue, Mixins } from 'vue-property-decorator';
import { Card, Option, Select } from 'element-ui';
import { billService } from '@/services/BillService';
import { statusOptions } from '@/constants/billStatusOptions';
import ScopedListBillsQuery from '@/graphql/queries/ScopedListBills.gql';
import Pagination from '@/mixins/pagination';
import customerOrganizations from '@/mixins/customerOrganizationOptions';
import {
  BillFields,
  BillScopedInput,
  BillStatusEnum
} from '@/types/graphql/schemaTypes';
import { utcToLocal } from '@/utilities/dateCast';

@Component({
  components: {
    'el-card': Card,
    'el-option': Option,
    'el-select': Select
  },
  apollo: {
    bills: {
      query: ScopedListBillsQuery,
      prefetch: true,
      variables() {
        const billArgs: BillScopedInput = {};

        if (this.selectedCustomerId) {
          billArgs.customerOrganizationId = this.selectedCustomerId;
        } else {
          billArgs.customerOrganizationId = null;
        }
        if (this.selectedField) {
          billArgs.sorting = {
            field: this.selectedField,
            order: this.billOrder
          };
        }
        return {
          billArgs,
          pagination: {
            page: parseInt(this.$route.query.page, 10) || this.currentPage,
            per: parseInt(this.$route.query.size, 10) || this.paginationSize
          }
        };
      },
      update(data) {
        this.totalCount = data.billsPagination.totalCount;
        return data.bills;
      },
      fetchPolicy: 'cache-and-network'
    }
  }
})
export default class List extends Mixins(Pagination, customerOrganizations) {
  private billOrder: 'asc' | 'desc' = 'asc';
  private readonly billStatusOptions = statusOptions();

  private selectedCustomerId = '';
  private selectedField = '';

  private billStatusClass(bill: BillFields) {
    const midnightToday = new Date(new Date().setHours(0, 0, 0, 0));

    if (
      bill.status === 'published' &&
      new Date(utcToLocal(bill.dueDate)) < midnightToday
    ) {
      return 'error';
    }

    if (bill.status === 'paid') {
      return 'success';
    }
  }

  private toggleSort(field: string): void {
    this.selectedField = field;
    this.billOrder = this.billOrder === 'desc' ? 'asc' : 'desc';
  }

  private async updateBill(id: string, status: BillStatusEnum) {
    try {
      const response = await billService.updateBill({ id, status });
      if (response) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }
}
